import { create } from "zustand";

const filterStore = (set, get) => ({
    filters: null, // Cached filters from API
    isFiltersLoading: false,
    
    setFilters: (filters) => {
        set({ filters });
    },
    
    setFiltersLoading: (loading) => {
        set({ isFiltersLoading: loading });
    },
});

const useFilterStore = create(filterStore);
export default useFilterStore;

